import { getAuthMenus } from '@/api/auth'

const TOKEN_KEY = 'sqx_admin_token'
const USERNAME_KEY = 'sqx_admin_username'
const ROLE_KEY = 'sqx_admin_role'
const MENUS_KEY = 'sqx_admin_menus'

export const ROLE_PROMO_PLATFORM = 'promo_platform'

const state = {
  token: localStorage.getItem(TOKEN_KEY) || '',
  username: localStorage.getItem(USERNAME_KEY) || '',
  roleName: localStorage.getItem(ROLE_KEY) || '',
  menus: JSON.parse(localStorage.getItem(MENUS_KEY) || '[]')
}

const getters = {
  isLoggedIn: (s) => !!s.token,
  menuPaths: (s) => (s.menus || []).map((m) => m.path),
  isPromoPlatformRole: (s) => s.roleName === ROLE_PROMO_PLATFORM,
  defaultHomePath: (s) => (s.roleName === ROLE_PROMO_PLATFORM ? '/promo-rebate-bill' : '/dashboard')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem(TOKEN_KEY, token)
    } else {
      localStorage.removeItem(TOKEN_KEY)
    }
  },
  SET_USERNAME(state, username) {
    state.username = username
    if (username) {
      localStorage.setItem(USERNAME_KEY, username)
    } else {
      localStorage.removeItem(USERNAME_KEY)
    }
  },
  SET_ROLE(state, roleName) {
    state.roleName = roleName || ''
    if (roleName) {
      localStorage.setItem(ROLE_KEY, roleName)
    } else {
      localStorage.removeItem(ROLE_KEY)
    }
  },
  SET_MENUS(state, menus) {
    state.menus = menus || []
    localStorage.setItem(MENUS_KEY, JSON.stringify(state.menus))
  }
}

const actions = {
  login({ commit, dispatch }, { token, username, roleName }) {
    commit('SET_TOKEN', token)
    commit('SET_USERNAME', username || '')
    commit('SET_ROLE', roleName || '')
    return dispatch('fetchMenus')
  },
  logout({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USERNAME', '')
    commit('SET_ROLE', '')
    commit('SET_MENUS', [])
  },
  async fetchMenus({ commit }) {
    const res = await getAuthMenus()
    const list = (res.data && res.data.list) || []
    commit('SET_MENUS', list)
    return list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
